import { render, staticRenderFns } from "./GruposLista.vue?vue&type=template&id=ff26da70&"
import script from "./GruposLista.vue?vue&type=script&lang=ts&"
export * from "./GruposLista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports